import React from "react";

export const Spinner = (props) => {
  const style = { height: (props.size || 15) + "px", width: (props.size || 15) + "px" };
  return <div className={"spinner-border " + props.className} align="center" role="status" style={style} />;
};
